import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src", "title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("iframe", {
    class: "block w-full border-none",
    ref: "frame",
    src: _ctx.src,
    title: _ctx.title
  }, null, 8, _hoisted_1))
}